import React from 'react';
import { required } from '../../../helpers/formValidators';

import {
  FormDateInput,
  FormLabel,
  FormTextArea,
  FormTimeInput
} from '../../form';

export default () => {
  return (
    <div>
      <div className="form-input--centered">
        <FormDateInput
          name="date"
          labelRenderer={() => (<FormLabel for="date">Date</FormLabel>)}
          dateFormat='MMM, dd yyyy'
          validate={required}
        />

        <FormTimeInput
          name="startTime"
          labelRenderer={() => (<FormLabel for="startTime">Time</FormLabel>)}
          validate={required}
        />
      </div>

      <FormTextArea
        maxLength={300}
        name="diaperNote"
        labelRenderer={() => (<FormLabel note='Optional'>Note</FormLabel>)}
      />
    </div>
  )
}




// WEBPACK FOOTER //
// ./src/components/ActivityTracker/FieldExcerpts/Diaper.js